import getIntl from 'Helpers/intl'
import { logAppError } from 'Helpers/logger'

import {
  toastShow,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_ERROR
} from 'mailup-web-components'

import { pageState } from '../state/page'
import { messageState } from '../state/message'
import {
  modalConfirmResetState,
  modalCreateTextVersionState
} from '../state/modals'
import {
  deletePlainText,
  getMessageDetails,
  getPlainText,
  saveMessage
} from '../actions/actions'

export const initCallback = ({ set }) => async idMessage => {
  set(pageState, prev => ({ ...prev, loading: true, error: false }))
  try {
    const messageDetails = await getMessageDetails(idMessage)
    set(messageState, prev => ({
      ...prev,
      ...messageDetails
    }))
  } catch (error) {
    logAppError({
      Component: 'TextVersion',
      Method: 'initCallback',
      appError: error
    })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailCheckUp.CannotRetrieveCommonInfoAlert'
      }),
      TOAST_VARIANT_ERROR,
      'CannotRetrieveCommonInfoAlert'
    )
    setTimeout(() => {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.EmailCheckUp.PlainTextVersionCannotGetPlainTextVersion'
        }),
        TOAST_VARIANT_ERROR,
        'getPlainTextVersion'
      )
    }, 1000)
  }
  set(pageState, prev => ({ ...prev, loading: false, loaded: true }))
}

export const createPlainTextCallback = ({ set, snapshot }) => async () => {
  const { idMessage } = await snapshot.getPromise(messageState)
  try {
    const plainText = await getPlainText(idMessage)
    set(messageState, prev => ({ ...prev, plainText, isDirty: true }))
  } catch (error) {
    logAppError({
      Component: 'TextVersion',
      Method: 'getTextVersionCallback',
      appError: error
    })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailCheckUp.PlainTextVersionCannotCreatePlainTextVersion'
      }),
      TOAST_VARIANT_ERROR,
      'createPlainTextVersion'
    )
  }
}

export const saveCallback = ({ set, snapshot }) => async () => {
  const { idMessage, plainText } = await snapshot.getPromise(messageState)
  try {
    await saveMessage(idMessage, plainText)
    set(messageState, prev => ({ ...prev, isDirty: false }))

    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailCheckUp.PlainTextVersionSuccessToast'
      }),
      TOAST_VARIANT_SUCCESS,
      'savePlainTextVersion'
    )
  } catch (error) {
    logAppError({
      Component: 'TextVersion',
      Method: 'saveCallback',
      appError: error
    })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailCheckUp.PlainTextVersionCannotSavePlainTextVersion'
      }),
      TOAST_VARIANT_ERROR,
      'savePlainTextVersion'
    )
  }
}

export const deletePlainTextCallback = ({ set, snapshot }) => async () => {
  const { idMessage } = await snapshot.getPromise(messageState)
  try {
    await deletePlainText(idMessage)
    set(messageState, prev => ({ ...prev, plainText: '', isDirty: true }))
  } catch (error) {
    logAppError({
      Component: 'TextVersion',
      Method: 'deletePlainTextCallback',
      appError: error
    })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailCheckUp.PlainTextVersionCannotDeletePlainTextVersion'
      }),
      TOAST_VARIANT_ERROR,
      'deletePlainTextVersion'
    )
  }
}

export const cleanupCallback = ({ reset }) => () => {
  reset(pageState)
  reset(messageState)
  reset(modalConfirmResetState)
  reset(modalCreateTextVersionState)
}
